import React, { useState, useEffect, useMemo } from 'react';

import { getOverviewTimeline } from '@/pages/opinion/services/performance';
import CardCommon from '@/pages/opinion/components/CardCommon';
import GamePCScoreBox from '../components/GamePCScoreBox';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { useRequestLifetimePcConsole } from '../hooks/useRequestLifetimePcConsole';
import useGetGameStoreStatsInfo from '../hooks/useGetGameStoreStatsInfo';

export default function PCScore({
  gameInfo,
  style,
  filter,
  hidePlayerAndViewer,
}: any) {
  const { formatMessage } = useLanguage();

  const params = useMemo(() => {
    if (filter && gameInfo) {
      const { channel, ...otherFilter } = filter;
      return {
        ...otherFilter,
        ...gameInfo,
        channels: ['steam', 'opencritic', 'metacritic'],
        device: '',
      };
    }

    return {};
  }, [filter]);

  const {
    loading: scoreLoading,
    data: storeScoreInfo,
    changeTime,
    show,
    time,
    isToday,
  } = useRequestLifetimePcConsole({
    filter: params,
  });

  const [steamReviews, setSteamReviews] = useState([]);
  const getPcGameStoreData = (params: any) => {
    const { social_media_by_account, social_media_by_keyword, ...otherFilter } =
      params;
    getOverviewTimeline({
      ...otherFilter,
      channel: ['steam'],
      channel_type: 'comments',
      metrics: ['recommend', 'non_recommend'],
      ret_metrics: ['recommend', 'non_recommend'],
      types: ['total'], // , 'slice'
    }).then((data: any) => {
      const { total_list } = data || {};

      setSteamReviews(total_list || []);
    });
  };

  useEffect(() => {
    if (Object.keys(filter || {}).length > 0) {
      getPcGameStoreData({ ...filter, ...gameInfo });
    }
  }, [filter, gameInfo]);

  const {
    loading: statsLoading,
    ratingInfo,
    ratings,
  } = useGetGameStoreStatsInfo({
    gameInfo,
    filter,
    type: 'xbox',
    lifetimeTitle: 'Lifetime Reviews',
    selectedTitle: 'Added Reviews',
  });

  return (
    <CardCommon
      className="feeds-gamestorebox"
      title={formatMessage({ id: 'Game Store' })}
    >
      <>
        <GamePCScoreBox
          loading={scoreLoading || statsLoading}
          storeScoreInfo={storeScoreInfo}
          changeTime={changeTime}
          steamReviews={steamReviews}
          xboxRatingInfo={ratingInfo}
          xboxRatings={ratings}
          show={show}
          time={time}
          filter={filter}
          isToday={isToday}
        />
      </>
    </CardCommon>
  );
}
